import { Permutive } from '../../../../services/analytics/tags/permutive'
import { PermutiveEvent } from '../../../../services/common/events/permutive'
import { AnalyticsEvent } from '../../event'
import { GlobalDataFormatter } from '../global-data'

export class PermutiveProvider extends AnalyticsEvent {

    private data: any
    private commonAttrs: string[] = []

    private keysMapping: any = {
        article_author_list: 'article_authors',
        article_tag_list: 'article_tags',
        nlp_category_list: 'nlp_category',
        nlp_entity_list: 'nlp_entity',
        secondary_categories_list: 'secondary_categories',
    }

    public constructor(data: any, type: string, value: string, action: string, element: Element) {
        super(type, value, action, element)
        this.data = data
    }

    /**
     * Handle event
     */
    public handle(): void {

        /**
         * Event Handler: updates the attributes list and sends it to permutive
         * @var data will be different for each event
         *
         */
        const permutive = new Permutive()
        let eventData: any = { ...this.data }  // extra data common to all providers

        const dataAttrs = this.getProviderAttributesList('permutive', this.commonAttrs)
        // Get Data Values ( this.metaProperties this is data coming from page-data )
        const globalFormatter = new GlobalDataFormatter(this.metaProperties)
        dataAttrs.forEach((attr) => {
            try {
                const attrValue = globalFormatter.lookup(attr)
                if(attrValue !== '' && attrValue.length > 0) {
                    eventData[attr] = attrValue
                }
            } catch(e) {
                console.error('GlobalDataFormatter error in class PermutiveProvider', e)
            }
        })

        const customData = this.getProviderCustomData('permutive')

        eventData = {
            ...eventData,
            ...customData
        }

        // Update keys names
        for(const mappedKey in this.keysMapping) {
            if (mappedKey in eventData) {
                eventData[this.keysMapping[mappedKey]] = eventData[mappedKey]
                delete eventData[mappedKey]
            }
        }
        if (this.action === 'page-load') {
            dispatchEvent(new CustomEvent(PermutiveEvent.FIRE_PAGE_VIEW,{
                detail: eventData
            }))
         } else if (this.type) {
            // send permutive event with attributes
            permutive.sendEvent(this.type, eventData)
        }
    }
}
